import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "sf-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MathLevelYearTabs = _resolveComponent("MathLevelYearTabs")!
  const _component_DbMathLevels = _resolveComponent("DbMathLevels")!
  const _component_UserArea = _resolveComponent("UserArea")!

  return (_openBlock(), _createBlock(_component_UserArea, { subject: "maths" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_ctx.yearTabs)
          ? (_openBlock(), _createBlock(_component_MathLevelYearTabs, {
              key: 0,
              modelValue: _ctx.defaultYear,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.defaultYear) = $event)),
              class: "tw-mb-4"
            }, null, 8, ["modelValue"]))
          : _createCommentVNode("", true),
        (_ctx.isReady)
          ? (_openBlock(), _createBlock(_component_DbMathLevels, {
              key: 1,
              "default-year": _ctx.defaultYear,
              "show-year-paging": _ctx.yearPaging,
              "teacher-mode": false
            }, null, 8, ["default-year", "show-year-paging"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }))
}